import React from 'react'
import {
  Section,
  ContainerLg,
  Lead,
  RowCentered,
  H2
} from '../../GlobalStylesNew'
import styled from 'styled-components'
import { Col } from 'reactstrap'
import theme from '../../theme'
import AppleStore from '../../../images/appstore.png'
import GooglePlay from '../../../images/googleplay.png'
import { myPgaIOSUrl, myPgaAndroidUrl } from '../../../constants'
import gtmEvent from '../../../utils/gtm'

export const DownloadSection = styled(Section)`
  background-color: #f4f6f8;
  padding: 50px 0 50px;
  text-align: left;
  @media screen and (min-width: 768px) {
    padding: 100px 0;
  }
  @media screen and (min-width: 1024px) {
    padding: 100px 0 150px;
  }
`
export const Heading = styled(H2)`
  text-align: center;
  color: ${theme.colors.navy};
  @media (min-width: 1024px) {
    margin-bottom: 50px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ buttons }) =>
    buttons > 1 ? 'space-around' : 'center'};
  width: 100%;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`

export const CustomLead = styled(Lead)`
  margin: 50px 0;
  text-align: center;
  color: ${theme.colors.navy};
`

const ButtonImageLink = styled.a`
  & + a {
    margin-top: 20px;
    @media (min-width: 768px) {
      margin-top: 0px;
    }
  }
`
const buttons = [
  {
    image: 'AppleStore',
    text: 'Apple Store',
    url: myPgaIOSUrl
  },
  {
    image: 'GooglePlay',
    text: 'Google Play',
    url: myPgaAndroidUrl
  }
]

const displayButtonImageLink = (url, image, text) => {
  switch (image) {
    case 'AppleStore':
      return (
        <ButtonImageLink
          href={url}
          key={url}
          onClick={() => {
            gtmEvent({
              event: 'index-page-click',
              indexPageCategory: 'download-app-cta',
              indexPageLabel: 'app-store',
              indexPageAction: 'click-app-store'
            })
          }}
        >
          <img src={AppleStore} alt={text} height='48' />
        </ButtonImageLink>
      )
    case 'GooglePlay':
      return (
        <ButtonImageLink
          href={url}
          key={url}
          onClick={() => {
            gtmEvent({
              event: 'index-page-click',
              indexPageCategory: 'download-app-cta',
              indexPageLabel: 'google-play',
              indexPageAction: 'click-google-play'
            })
          }}
        >
          <img src={GooglePlay} alt={text} height='48' />
        </ButtonImageLink>
      )
    default:
      return null
  }
}

const Download = props => {
  return (
    <DownloadSection id='download'>
      <ContainerLg>
        <Heading>
          Download the
          <br />
          Mobile App Today
        </Heading>
        <CustomLead>
          The power to manage your coaching business is now in your pocket
        </CustomLead>
        <RowCentered>
          <Col xl='4' lg='5' md='6'>
            <ButtonsContainer buttons={buttons.length}>
              {buttons.map((button, i) => {
                const { url, image, text } = button
                return displayButtonImageLink(url, image, text)
              })}
            </ButtonsContainer>
          </Col>
        </RowCentered>
      </ContainerLg>
    </DownloadSection>
  )
}

export default Download
